import { render, staticRenderFns } from "./LightingSystem.vue?vue&type=template&id=35112779&scoped=true&"
import script from "./LightingSystem.vue?vue&type=script&lang=js&"
export * from "./LightingSystem.vue?vue&type=script&lang=js&"
import style0 from "./LightingSystem.vue?vue&type=style&index=0&id=35112779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35112779",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35112779')) {
      api.createRecord('35112779', component.options)
    } else {
      api.reload('35112779', component.options)
    }
    module.hot.accept("./LightingSystem.vue?vue&type=template&id=35112779&scoped=true&", function () {
      api.rerender('35112779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/assessments/LightingSystem.vue"
export default component.exports